import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SsoLoginService } from '../../../SsoAuth/Service/sso-login.service';
import { GetAccessTokenService } from '../../../SsoAuth/Service/get-access-token.service';
import { SsoAuthService } from '../../../SsoAuth/Service/sso-auth.service';
import { IdleTimerService } from '../../../SsoAuth/Service/idle-timer.service';
import { RequestMapper } from '../../request-mapper';
import {
  parseEstablishmentId,
  serializePermissionSource,
} from '../../common-files/permission-tree';
import { ContextService } from '../../services/context/context.service';
import { take } from 'rxjs/operators';
// import { GetAccessTokenService } from 'app/SsoAuth/Service/get-access-token.service';
// import { IdleTimerService } from 'app/SsoAuth/Service/idle-timer.service';
// import { SsoAuthService } from 'app/SsoAuth/Service/sso-auth.service';
// import { SsoLoginService } from 'app/SsoAuth/Service/sso-login.service';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-loader-screen',
  standalone: true,
  imports: [],
  templateUrl: './loader-screen.component.html',
  styleUrl: './loader-screen.component.scss',
})
export class LoaderScreenComponent implements OnInit {
  showRetry: boolean = false;

  constructor(
    private router: Router,
    private activeroute: ActivatedRoute,
    private ssologin: SsoLoginService,
    private ssoauth: GetAccessTokenService,
    // private toaster: ToastrService,
    private authService: SsoAuthService,
    private idleTimerService: IdleTimerService,
    private contextService: ContextService
  ) { }
  ngOnInit() {
    const token = localStorage.getItem('userToken');

    this.activeroute.queryParams.pipe(take(1)).subscribe((params) => {
      const accessCode = params['accessCode'];
      
      if (accessCode) {
        localStorage.setItem('accessCode', accessCode);
        const codeVerifier = localStorage.getItem('sso_code_verifier');

        const payload = {
          accessCode: accessCode,
          codeVerifier: codeVerifier,
        };

        this.ssoauth.getAccessToken(payload).subscribe({
          next: (response: any) => {
            // if (
            //   response?.data?.newDevotee !== undefined &&
            //   response.data.newDevotee === true
            // ) {
            //   localStorage.setItem('stateToken', response.data.stateToken);
            //   // localStorage.setItem(
            //   //   'register_memberdetails',
            //   //   JSON.stringify(response.data.memberDetails)
            //   // );
            //   this.router.navigateByUrl('/register');
            //   return;
            // }

            // this.toaster.success(response.message || 'Login Successful!');
            const responseData = response?.data ?? {};
            const establishments = Array.isArray(responseData.establishments)
              ? responseData.establishments
              : [];
            const scopedPermissions = responseData.permissions !== null
              && typeof responseData.permissions === 'object'
              && !Array.isArray(responseData.permissions)
              ? responseData.permissions
              : null;
            const isSuperAdmin = responseData.isSuperAdmin === true || responseData.role === 'SUPER_ADMIN';

            // Scope, branch, and property context must belong to this login
            // response, never to a previous browser session.
            localStorage.removeItem('activeScope');
            localStorage.removeItem('activeEstablishmentId');
            localStorage.removeItem('activeEstablishmentName');
            localStorage.removeItem('activePropertyId');
            localStorage.removeItem('activePropertyName');
            localStorage.removeItem('permissions');
            localStorage.removeItem('permissionsScoped');
            localStorage.removeItem('viewAs');
            localStorage.removeItem('viewAsBackup');

            localStorage.setItem('userToken', responseData.accessToken);
            localStorage.setItem('fullName', responseData.fullName);
            localStorage.setItem('role', responseData.role);
            localStorage.setItem('roleName', responseData.roleName);
            localStorage.setItem('isSuperAdmin', String(isSuperAdmin));
            if (scopedPermissions) {
              localStorage.setItem(
                'permissionsScoped',
                JSON.stringify(scopedPermissions),
              );
            } else {
              // Legacy permissionsV2 is already a single applied context. Keep
              // its source payload intact so validUntil is checked on every read.
              localStorage.setItem(
                'permissions',
                serializePermissionSource(responseData),
              );
            }
            localStorage.setItem(
              'roleDetails',
              JSON.stringify(responseData.roleDetails || []),
            );
            localStorage.setItem('establishments', JSON.stringify(establishments));
            localStorage.setItem('hasAllBranches', String(responseData.hasAllBranches ?? false));
            localStorage.setItem('isLoggedIn', 'true');
            this.authService.initTimer();

            this.idleTimerService.startWatching(() => {
              console.log('Logging out due to inactivity...');
              this.authService.logOut(false);
            });

            if (isSuperAdmin) {
              // super admin starts in the global context (branch picker + "Change
              // context" are available in the sidebar) and lands on Users
              if (scopedPermissions) this.contextService.applyGlobal();
              this.router.navigateByUrl(`${RequestMapper.SIDENAV}/${RequestMapper.SA_USERS}`);
            } else if (scopedPermissions && (
              this.contextService.needsScopeChoice() ||
              this.contextService.needsEstablishmentChoice()
            )) {
              // both global + establishment access, or multiple establishments -> ask
              this.router.navigateByUrl(`/${RequestMapper.SELECT_CONTEXT}`);
            } else if (scopedPermissions) {
              // a single obvious context — apply it and land on the first menu route
              this.contextService.applyDefault();
              const route = this.contextService.firstRoute();
              this.router.navigateByUrl(
                route ? `${RequestMapper.SIDENAV}/${route}` : `${RequestMapper.SIDENAV}`
              );
            } else {
              // Compatibility for the permissionsV2 response while the API is
              // transitioning to scoped permissions.
              const activeEstablishmentId = parseEstablishmentId(
                establishments[0]?.establishmentId,
              );
              if (activeEstablishmentId !== null) {
                localStorage.setItem(
                  'activeEstablishmentId',
                  String(activeEstablishmentId),
                );
                localStorage.setItem(
                  'activeEstablishmentName',
                  establishments[0]?.name || '',
                );
              }
              const route = this.contextService.firstRoute();
              this.router.navigateByUrl(route
                ? `${RequestMapper.SIDENAV}/${route}`
                : `${RequestMapper.SIDENAV}/${RequestMapper.PROFILE_SEARCH}`);
            }
            // this.router.navigateByUrl('/accomodation/regularbooking');
            // localStorage.setItem(
            //   'profileDetails',
            //   JSON.stringify(response.data.profileDetails)
            // );
          },
          error: (error: any) => {
            console.error('Access Token API Error:', error);
            this.showRetry = true;
            // this.toaster.error(
            //   error.msg || 'Something went wrong while logging in!'
            // );
          },
        });
      } else {
        if (token) {
          if (localStorage.getItem('isSuperAdmin') === 'true') {
            if (
              !localStorage.getItem('permissions')
              && localStorage.getItem('permissionsScoped')
            ) {
              this.contextService.applyGlobal();
            }
            this.router.navigateByUrl(
              `${RequestMapper.SIDENAV}/${RequestMapper.SA_USERS}`,
            );
          } else if (
            !localStorage.getItem('permissions')
            && localStorage.getItem('permissionsScoped')
            && (
              this.contextService.needsScopeChoice()
              || this.contextService.needsEstablishmentChoice()
            )
          ) {
            this.router.navigateByUrl(`/${RequestMapper.SELECT_CONTEXT}`);
          } else {
            if (
              !localStorage.getItem('permissions')
              && localStorage.getItem('permissionsScoped')
            ) {
              this.contextService.applyDefault();
            }
            const route = this.contextService.firstRoute();
            this.router.navigateByUrl(route
              ? `${RequestMapper.SIDENAV}/${route}`
              : `${RequestMapper.SIDENAV}`);
          }
        } else {
          this.ssologin.login();
        }
      }
    });

    //  if (!token) {
    //   setTimeout(() => {
    //     this.ssologin.login()
    //   }, 1000);
    // }
  }
  onRetry() {
    this.showRetry = false;
    this.ssologin.login();
  }
}
